module.exports = __webpack_public_path__ + "img/watcher-icon-2.cf915956.svg";